export const INFORMATION_FORM_NAME = 'information';



// WEBPACK FOOTER //
// ./src/modules/InformationForm/constants.js